<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<p class="center ">First Mariner Books edition 2011</p>
<p class="center spaceabove1">Copyright © 1964 by Philip K. Dick</p>
<p class="center ">Copyright renewed 1992 by Laura Coelho, Christopher Dick, and Isa Hackett</p>
<p class="center spaceabove1"><a id="px0"></a>Originally published by Belmont Books in 1964.</p>
<p class="center spaceabove1">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1">
<a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a>
</p>
<p class="center spaceabove1">
<em>Library of Congress Cataloging-in-Publication Data</em>
</p>
<p class="center ">Dick, Philip K.</p>
<p class="center ">The penultimate truth / Philip K. Dick.—1st Mariner Books ed.</p>
<p class="center ">p. cm.</p>
<p class="center ">ISBN 978-0-547-57247-5</p>
<p class="center ">1. Nuclear warfare—Fiction. 2. Underground areas—Fiction. 3. Regression (Civilization)—Fiction. I. Title. </p>
<p class="center ">PS3554.I3P4 2011</p>
<p class="center ">813'.54—dc22</p>
<p class="center ">2011015942</p>
<p class="center spaceabove1">eISBN 978-0-547-60135-9<br/>
v2.0620</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?4a7a4e65